import { useEffect, useState } from "react";
import { toast } from "sonner";
import { RefreshCw, Sheet } from "lucide-react";
import { useApi, errMsg } from "@/lib/api";

export const OutletTab = () => {
  const call = useApi();
  const [info, setInfo] = useState(null);
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => call("get", "/admin/outlet").then((r) => { setInfo(r.data); setUrl((u) => u || r.data.sheet_url); });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, []);

  const sync = async () => {
    setBusy(true);
    try {
      const { data } = await call("post", "/admin/outlet/sync", { sheet_url: url });
      toast.success(`${data.created} nuevos · ${data.updated} actualizados · ${data.visible} a la venta`);
      load();
    } catch (e) { toast.error(errMsg(e, "No se pudo actualizar")); }
    setBusy(false);
  };

  const r = info?.last_result;
  return (
    <div className="bg-white border p-6 max-w-3xl space-y-5" data-testid="admin-outlet-tab">
      <p className="filter-title flex items-center gap-2"><Sheet className="w-4 h-4" /> Outlet desde Google Sheets</p>
      <p className="text-sm text-slate-600">Lee la pestaña <b>"Catálogo Outlet"</b>. Agrupa las tallas por marca + modelo + color, usa el precio más bajo (rebajado → oferta → PVP) y muestra el PVP tachado. Los artículos sin foto o sin stock quedan ocultos; los que ya no estén en la hoja se ocultan.</p>
      <p className="text-sm font-semibold text-verde" data-testid="outlet-auto-note">Se actualiza automáticamente cada hora (y envía los avisos de talla). Pulsa el botón si quieres hacerlo al momento.</p>
      {info?.last_auto_error && <p className="text-xs text-rose-600" data-testid="outlet-auto-error">Última actualización automática fallida ({new Date(info.last_auto_error.at).toLocaleString("es-ES")}): {info.last_auto_error.detail}</p>}
      <label className="block">
        <span className="text-xs font-semibold text-slate-600">Enlace de la hoja (compartida como "cualquier persona con el enlace")</span>
        <input className="field mt-1" value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://docs.google.com/spreadsheets/d/…" data-testid="outlet-sheet-url" />
      </label>
      <button className="btn-primary !h-11" onClick={sync} disabled={busy} data-testid="outlet-sync-button">
        <RefreshCw className={`w-4 h-4 ${busy ? "animate-spin" : ""}`} /> {busy ? "Actualizando…" : "Actualizar desde la hoja"}
      </button>
      {info && (
        <div className="grid sm:grid-cols-3 gap-3 text-sm" data-testid="outlet-stats">
          <div className="bg-slate-50 p-3"><p className="text-xs text-slate-500">Artículos outlet</p><p className="font-bold text-lg" data-testid="outlet-count">{info.products}</p></div>
          <div className="bg-slate-50 p-3"><p className="text-xs text-slate-500">A la venta</p><p className="font-bold text-lg" data-testid="outlet-visible">{info.visible}</p></div>
          <div className="bg-slate-50 p-3"><p className="text-xs text-slate-500">Última actualización</p><p className="font-bold">{info.last_sync ? new Date(info.last_sync).toLocaleString("es-ES") : "Nunca"}</p></div>
        </div>
      )}
      {r && <p className="text-xs text-slate-500" data-testid="outlet-last-result">Última lectura: {r.rows} filas → {r.products} artículos ({r.created} nuevos, {r.updated} actualizados, {r.hidden_missing} retirados).</p>}
      {r?.broken_images?.length > 0 && (
        <div className="border border-amber-300 bg-amber-50 p-4 text-sm" data-testid="outlet-broken-images">
          <p className="font-semibold text-amber-800">{r.broken_images.length} artículos con fotos que no existen en Netlify (no se muestran):</p>
          <ul className="mt-2 space-y-1 text-xs text-amber-900 max-h-48 overflow-y-auto">
            {r.broken_images.map((b, i) => <li key={i}><b>{b.name}</b> — {b.urls.map((u) => u.split("/").pop()).join(", ")}</li>)}
          </ul>
        </div>
      )}
    </div>
  );
};
